import React, {
    createContext, useCallback, useContext, useEffect, useMemo, useState,
} from 'react';
import { BasketContext } from './BasketProvider';

export const NYGiftContext = createContext({});

interface INYGiftProviderProps {
    children: React.ReactNode
}

type GiftDishId = '3835' | '4211' | '3834' | '3897'

const fillDishQueueWithGift = (
    // TODO: get basket data type from gql
    // @ts-ignore
    basket,
    id: string,
    giftId: string,
) => {
    let initialList: GiftDishId[] = [];

    const one = basket.sections.filter((section: any) => section.id === '5');
    const two = one.map((section: any) => section.items);
    const three = two.map((item: any) => item);
    three.forEach((ele: any) => {
        ele.forEach((ele2: any) => {
            if (ele2.dish_id === id || ele2.dish_id === giftId) {
                const result = new Array(ele2.portions).fill(ele2.dish_id);
                initialList = [...initialList, ...result];
            }
        });
    });

    return initialList;
};

export function NYGiftProvider(props: INYGiftProviderProps) {
    const { children } = props;
    const { basket } = useContext(BasketContext);

    // '3834', '3897' Каварижка
    const [giftOneItemList, setGiftOneItemList] = useState<GiftDishId[]>([]);
    // '3835', '4211' Кантуччи
    const [giftTwoItemList, setGiftTwoItemList] = useState<GiftDishId[]>([]);

    const [isGiftItemOneSelected, setIsGiftItemOneSelected] = useState(false);
    const [isGiftItemTwoSelected, setIsGiftItemTwoSelected] = useState(false);

    useEffect(() => {
        if (basket.sections.length) {
            const resultOne = fillDishQueueWithGift(basket, '3834', '3897');
            const resultTwo = fillDishQueueWithGift(basket, '4211', '3835');
            setGiftOneItemList(resultOne);
            setGiftTwoItemList(resultTwo);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // eslint-disable-next-line react-hooks/exhaustive-deps
    // TEMPORARY HIDDEN DISHES WITH GIFT WRAP
    // const isGiftItem = (id: string) => ['4211', '3897', '3834', '3835'].includes(String(id));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const isGiftItem = (id: string) => false;

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const getItemsListById = (id: string) => {
        if (['3834', '3897'].includes(id)) {
            return {
                itemsList: giftOneItemList,
                setItemsList: setGiftOneItemList,
                isGiftItemSelected: isGiftItemOneSelected,
                setIsGiftItemSelected: setIsGiftItemOneSelected,
                name: 'gingerbread',
            };
        }

        return {
            itemsList: giftTwoItemList,
            setItemsList: setGiftTwoItemList,
            isGiftItemSelected: isGiftItemTwoSelected,
            setIsGiftItemSelected: setIsGiftItemTwoSelected,
            name: 'cantucci',
        };
    };

    const removeHeadItem = useCallback((id: string) => {
        const { itemsList, setItemsList } = getItemsListById(id);
        const tail = itemsList.length - 1;
        const lastItemId = itemsList[tail];
        if (tail > -1) {
            const nextState = itemsList.slice(0, -1);
            setItemsList(nextState);
        }
        return lastItemId;
    }, [getItemsListById]);

    const romoveById = useCallback((id: GiftDishId) => {
        const { itemsList } = getItemsListById(id);

        const lastIndex = itemsList.lastIndexOf(id);
        if (lastIndex > -1) {
            itemsList.splice(lastIndex, 1);
        }
    }, [getItemsListById]);

    const addHeadItem = useCallback((id: GiftDishId) => {
        const { itemsList, setItemsList } = getItemsListById(id);
        setItemsList([...itemsList, id]);
    }, [getItemsListById]);

    const removeAllById = useCallback((id: GiftDishId) => {
        const { itemsList, setItemsList } = getItemsListById(id);
        const nextState = itemsList.filter((item) => item !== id);
        setItemsList(nextState);
    }, [getItemsListById]);

    const NYGiftContextValue = useMemo(
        () => ({
            removeHeadItem,
            addHeadItem,
            removeAllById,
            giftOneItemList,
            giftTwoItemList,
            romoveById,
            isGiftItem,
            getItemsListById,
        }),
        [
            removeHeadItem,
            addHeadItem,
            giftOneItemList,
            giftTwoItemList,
            romoveById,
            removeAllById,
            isGiftItem,
            getItemsListById,
        ],
    );

    return (
        <NYGiftContext.Provider value={NYGiftContextValue}>
            {children}
        </NYGiftContext.Provider>
    );
}
